import { Link } from 'react-router-dom';
import { categoryLabel, guidePath } from '../constants/guides';
import Icon from './Icon';

export default function GuideCard({ guide }) {
  return (
    <Link to={guidePath(guide.slug)} className="guide-card">
      <span className="guide-card__cat">{categoryLabel(guide.category)}</span>
      <h3>{guide.title}</h3>
      <p>{guide.summary}</p>
      <span className="guide-card__more">
        {guide.readTime} <Icon name="arrow" size={18} />
      </span>
    </Link>
  );
}
